// Keep supported direct-link search options when the native GET form is used.
export function initializeSearch(form, view = window) {
  const params = new URLSearchParams(view.location.search);
  const options = {
    'options[prefix]': ['last', 'none'],
    'options[unavailable_products]': ['show', 'hide', 'last'],
  };
  for (const [name, allowed] of Object.entries(options)) {
    const value = params.get(name);
    const input = form.elements.namedItem(name);
    if (input && allowed.includes(value)) input.value = value;
  }
}
if (typeof document !== 'undefined') {
  for (const form of document.querySelectorAll('[data-reno-search]')) initializeSearch(form);
}
